import { Autocomplete, Box, TextField } from "@mui/material";
import CountriesTurkishSorted from "../../../utils/CountriesTurkishSorted";

const OrderSenderCountrySearch = ({ orderSenCountry, setOrderSenCountry }) => {
  return (
    <Autocomplete
      id="country-sender-country-select"
      fullWidth
      size="small"
      options={CountriesTurkishSorted()}
      autoHighlight
      value={CountriesTurkishSorted().find((option) => option.iso_code === orderSenCountry) || null}
      onChange={(e, val) => {
        if (val) {
          setOrderSenCountry(val.iso_code);
        } else {
          setOrderSenCountry("");
        }
      }}
      getOptionLabel={(option) => `${option.country_name_tr}, ${option.country_name_en}`}
      renderOption={(props, option) => (
        <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.iso_code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.iso_code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.country_name_tr}, {option.country_name_en}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          autoComplete="off"
          label="Gönderici Ülkesi"
          value={orderSenCountry}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
};

export default OrderSenderCountrySearch;
